import AbstractStoreService from "../Framework/Services/AbstractStoreService";

/**
 * Map of the provided services
 * @type {{}}
 * @private
 */
const services = {};

/**
 * Runs the init function after all the services are added
 * this provides the opportunity to access other services while doing the custom initialization
 * @private
 */
const runInitForCurrentServices = () => {
  const keys = Object.keys(services);
  for (let k of keys) {
    const service = services[k];
    service.init && service.init();
  }
};

export default class ServiceLocator {
  /**
   * Instantiates the given services then calls the runInitForCurrentServices function
   * @param {{}} services The object that contains all the services
   */
  static useServiceMap(services) {
    const keys = Object.keys(services);
    for (let k of keys) {
      const Service = services[k];
      this.provide(new Service());
    }
    runInitForCurrentServices();
  }

  static provide(serviceInstance) {
    if (serviceInstance.constructor && serviceInstance.constructor.serviceName) {
      services[serviceInstance.constructor.serviceName] = serviceInstance;
    } else {
      throw new TypeError("The service must have a serviceName property in its constructor!");
    }
  }

  static getServiceInstanceByName(serviceName) {
    if (services[serviceName]) {
      return services[serviceName];
    } else {
      throw new TypeError(`Service does not exist: ${serviceName}`);
    }
  }

  static getServiceInstanceByConstructor(constructor) {
    if (constructor.serviceName) {
      return this.getServiceInstanceByName(constructor.serviceName);
    } else {
      throw new TypeError("Missing service name parameter in the constructor!");
    }
  }

  /**
   *
   * @returns {AbstractStoreService}
   */
  static getStoreService() {
    return this.getServiceInstanceByConstructor(AbstractStoreService);
  }
}

/**
 * Service collection to get them in runtime
 */
export class Services {
  /**
   *
   * @returns {AbstractStoreService}
   */
  static get store() {
    return ServiceLocator.getStoreService();
  }

  /**
   *
   * @param {string} serviceName
   * @returns {*}
   */
  static get(serviceName) {
    return ServiceLocator.getServiceInstanceByName(serviceName);
  }
}

// expose Services to the window in dev mode so it can be used from the console
if (process.env.NODE_ENV !== "production") {
  window.Services = Services;
}
